import { useBuyerOrderList } from "../../../../hooks/api/v2/order/useBuyerOrderList";
import { useDebounce } from "use-debounce";
import { useShallow } from "zustand/react/shallow";
import { AllOrdersList } from "./AllOrdersList";
import {
  OrderContainsValues,
  OrderFulfillmentFilterValues,
  OrderListSortValues,
  OrderPaymentStatusValues,
  OrderPaymentTypeValues,
} from "./AllOrdersListFilterTypes";
import { useAllOrdersListStore } from "./AllOrdersListStore";

export const BuyerAllOrdersList = ({
  selectedOrderId,
}: {
  selectedOrderId: number | null;
}) => {
  const state = useAllOrdersListStore(useShallow((state) => state));

  const [debouncedStoreSearchValue] = useDebounce(state.search, 500);

  const query = useBuyerOrderList({
    limit: 20,
    query: [
      ...(state.orderStatuses.length > 0
        ? ([
            {
              type: "orderStatuses",
              value: state.orderStatuses,
              modifier: "EQUALS",
            },
          ] as const)
        : []),
      ...(state.deliveryStatus
        ? OrderFulfillmentFilterValues[state.deliveryStatus].mutation(
            state.deliveryStatus,
          )
        : []),
      ...(state.paymentStatus
        ? OrderPaymentStatusValues[state.paymentStatus].mutation(
            state.paymentStatus,
          )
        : []),
      ...(state.paymentType
        ? OrderPaymentTypeValues[state.paymentType].mutation(state.paymentType)
        : []),
      ...(state.orderContains
        ? OrderContainsValues[state.orderContains].mutation(state.orderContains)
        : []),
      ...(!!debouncedStoreSearchValue
        ? [
            {
              type: "searchAny",
              modifier: "INCLUDES",
              value: debouncedStoreSearchValue,
            } as const,
          ]
        : []),
    ].flatMap((x) => (x ? x : [])),
    ...(state.sort && OrderListSortValues[state.sort]
      ? {
          sortBy: OrderListSortValues[state.sort].mutation.type,
          sortDir: OrderListSortValues[state.sort].mutation.direction,
        }
      : {}),
  });
  return <AllOrdersList query={query} selectedOrderId={selectedOrderId} />;
};
